module.exports = __webpack_public_path__ + "media/images/top-parts-01-87821d4bd499344689ad5a3bf73d9c4c.jpg";